export default __webpack_public_path__ + "images/5H.dd18253.png";